var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#header'),expression:"'#header'"}],staticClass:"scroller",class:{ 'scroller--hidden': !_vm.isVisible }},[_c('unicon',{staticClass:"scroller__arrow",attrs:{"name":"arrow-up","height":"40","width":"40"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }